var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramFinal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6073_8337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20.5C16.0228 20.5 20.5 16.0228 20.5 10.5C20.5 4.97715 16.0228 0.5 10.5 0.5C4.97715 0.5 0.5 4.97715 0.5 10.5C0.5 16.0228 4.97715 20.5 10.5 20.5Z",
    fill: "url(#paint0_linear_6073_8337)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.39588 10.1493C7.89413 8.6252 10.2268 7.6204 11.394 7.13493C14.7266 5.74882 15.419 5.50804 15.8704 5.50008C15.9696 5.49834 16.1916 5.52294 16.3354 5.6396C16.4568 5.73811 16.4902 5.87118 16.5062 5.96458C16.5221 6.05797 16.542 6.27073 16.5262 6.43698C16.3456 8.33446 15.5642 12.9392 15.1667 15.0644C14.9985 15.9636 14.6672 16.2651 14.3466 16.2946C13.6497 16.3588 13.1206 15.8341 12.4456 15.3917C11.3895 14.6994 10.7928 14.2684 9.76761 13.5928C8.58283 12.8121 9.35087 12.3829 10.0261 11.6816C10.2028 11.4981 13.2732 8.70536 13.3326 8.45201C13.34 8.42032 13.3469 8.30222 13.2768 8.23985C13.2066 8.17749 13.103 8.19881 13.0283 8.21577C12.9224 8.23981 11.2352 9.35501 7.96663 11.5613C7.48772 11.8902 7.05394 12.0504 6.66528 12.042C6.23682 12.0328 5.41263 11.7998 4.79993 11.6006C4.04843 11.3563 3.45115 11.2272 3.50316 10.8123C3.53025 10.5962 3.82782 10.3752 4.39588 10.1493Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6073_8337",
    x1: 10.5,
    y1: 0.5,
    x2: 10.5,
    y2: 20.3517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6073_8337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramFinal);
export default __webpack_public_path__ + "static/media/telegram-final.0e02a5221871268f317a51d6b6c7acf7.svg";
export { ForwardRef as ReactComponent };